<template>
    <div class="streamcontainer game-webcams">
        <div :class="['game-webcam', 'stream', streamVisible(streams[0]) ? '': 'd-none', 'user-' + streams[0]['user_id'], streams[0].name.indexOf('Board') != -1 ? 'board-stream' : 'player-stream', 'player-number-' + streams[0]['player_number']]" v-if="streams[0]" id="videostream1">
            <video autoplay ref="viewer" :class="['webcamvideo', streams[0]['cameraoptions'].rotation == 180 ? 'rotate180' : '']" id="video1" :muted="ownCameraCheck(streams[0])" v-if="ingamePlayer()"></video>
            <img :ref="'stream-' + streams[0]['id']" class="webcamvideo webcamimage" v-if="!ingamePlayer()">

            <div class="overlay" @click="reconnect" v-if="ingamePlayer()">
                <div class="overlay-center">
                    <div v-if="!stream1 || !stream1.streamActive">
                        <i class="far fa-play-circle"></i>
                    </div>
                    <div class="streamloader text-center" v-if="stream1 && stream1.streamActive && !stream1.streamLoaded">
                        <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                        </div>
                    </div>

                    <span class="text" v-if="!stream1 || !stream1.streamActive">{{streams[0]['name']}}</span>
                    <div class="textLive" v-if="stream1 && stream1.streamActive && webcamDisplayStreamName">{{streams[0]['name']}}</div>
                    <div class="streamId" v-if="webcamDisplayStreamId">{{streams[0]['id']}}</div>
                    <div class="streamIcon"></div>
                </div>
            </div>
            <div class="overlay" v-else>
                <div class="overlay-center">
                    <div class="streamIcon"></div>
                    <div class="textLive">{{streams[0]['name']}}</div>
                </div>
            </div>
        </div>

        <div :class="['game-webcam', 'stream', streamVisible(streams[1])  ? '': 'd-none', 'user-' + streams[1]['user_id'], streams[1].name.indexOf('Board') != -1 ? 'board-stream' : 'player-stream', 'player-number-' + streams[1]['player_number']]" v-if="streams[1]" id="videostream2">
            <video autoplay ref="viewer2" :class="['webcamvideo', streams[1]['cameraoptions'].rotation == 180 ? 'rotate180' : '']" id="video2" :muted="ownCameraCheck(streams[1])" v-if="ingamePlayer()"></video>
            <img :ref="'stream-' + streams[1]['id']" class="webcamvideo webcamimage" v-if="!ingamePlayer()">

            <div class="overlay" @click="reconnect" v-if="ingamePlayer()">
                <div class="overlay-center">
                    <div v-if="!stream2 || !stream2.streamActive">
                        <i class="far fa-play-circle"></i>
                    </div>
                    <div class="streamloader text-center" v-if="stream2 && stream2.streamActive && !stream2.streamLoaded">
                        <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <span class="text" v-if="!stream2 || !stream2.streamActive">{{streams[1]['name']}}</span>
                    <div class="textLive" v-if="stream2 && stream2.streamActive && webcamDisplayStreamName">{{streams[1]['name']}}</div>
                    <div class="streamId" v-if="webcamDisplayStreamId">{{streams[1]['id']}}</div>
                    <div class="streamIcon"></div>
                </div>
            </div>
            <div class="overlay" v-else>
                <div class="overlay-center">
                    <div class="streamIcon"></div>
                    <div class="textLive">{{streams[1]['name']}}</div>
                </div>
            </div>
        </div>

        <div :class="['game-webcam', 'stream', streamVisible(streams[2])  ? '': 'd-none', 'user-' + streams[2]['user_id'], streams[2].name.indexOf('Board') != -1 ? 'board-stream' : 'player-stream', 'player-number-' + streams[2]['player_number']]" v-if="streams[2]" id="videostream3">
            <video autoplay ref="viewer3" :class="['webcamvideo', streams[2]['cameraoptions'].rotation == 180 ? 'rotate180' : '']" id="video3" :muted="ownCameraCheck(streams[2])"></video>
            <div class="overlay" @click="reconnect">
                <div class="overlay-center">
                    <div v-if="!stream3 || !stream3.streamActive">
                        <i class="far fa-play-circle"></i>
                    </div>
                    <div class="streamloader text-center" v-if="stream3 && stream3.streamActive && !stream3.streamLoaded">
                        <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <span class="text" v-if="!stream3 || !stream3.streamActive">{{streams[2]['name']}}</span>
                    <div class="textLive" v-if="stream3 && stream3.streamActive && webcamDisplayStreamName">{{streams[2]['name']}}</div>
                    <div class="streamId" v-if="webcamDisplayStreamId">{{streams[2]['id']}}</div>
                    <div class="streamIcon"></div>
                </div>
            </div>
        </div>

        <div :class="['game-webcam', 'stream', streamVisible(streams[3])  ? '': 'd-none', 'user-' + streams[3]['user_id'], streams[3].name.indexOf('Board') != -1 ? 'board-stream' : 'player-stream', 'player-number-' + streams[3]['player_number']]" v-if="streams[3]" id="videostream4">
            <video autoplay ref="viewer4" :class="['webcamvideo', streams[3]['cameraoptions'].rotation == 180 ? 'rotate180' : '']" id="video4" :muted="ownCameraCheck(streams[3])"></video>
            <div class="overlay" @click="reconnect">
                <div class="overlay-center">
                    <div v-if="!stream4 || !stream4.streamActive">
                        <i class="far fa-play-circle"></i>
                    </div>
                    <div class="streamloader text-center" v-if="stream4 && stream4.streamActive && !stream4.streamLoaded">
                        <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                    <span class="text" v-if="!stream4 || !stream4.streamActive">{{streams[3]['name']}}</span>
                    <div class="textLive" v-if="stream4 && stream4.streamActive && webcamDisplayStreamName">{{streams[3]['name']}}</div>
                    <div class="streamId" v-if="webcamDisplayStreamId">{{streams[3]['id']}}</div>
                    <div class="streamIcon"></div>
                </div>
            </div>
        </div>

        <div :class="['game-webcam', 'stream'] " v-if="streams.length == 0" id="novideostreams"/>
    </div>
</template>

<script>
import WebcamStream from "../webcam"
export default {
  name: "Viewer",
  props: [
    "auth_user_id",
    "stream_id",
    "stream_ids"
  ],
  data() {
    return {
      streams: [],
      stream1: null,
      stream2: null,
      stream3: null,
      stream4: null,
      webcamDisplayOption: 'webcamDisplayActivePlayer',
      webcamDisplayStreamId: true,
      webcamDisplayStreamName: true,
      broadcastStarted: false,
      boardcamtest: null,
      allowConnection: true,
      players: [],
      currentUser: null,
      blockDoubleJoin: false,
    };
  },
  created() {
      this.streams = JSON.parse(this.stream_ids);
      console.log("loading view for ", this.streams)
  },
  mounted() {
       this.$root.$emit('ProfileSelectorAddObserver', this.loadProfile)

       var self = this;
        window.onbeforeunload = function (e) {
            console.log("closing all streams")
            if (self.stream1) self.stream1.removeBroadcastVideo()
            if (self.stream2) self.stream2.removeBroadcastVideo()
            if (self.stream3) self.stream3.removeBroadcastVideo()
            if (self.stream4) self.stream4.removeBroadcastVideo()
            // return "Close";
        };

        window.connection.subscribe(this);
        this.update(window.connection.lastUpdate);

        // this.$root.$on("GameManagerScreenshot", (data) => {
        //     this.refreshCams()
        // });
        // this.refreshCams();

        // this.$root.$on("GameManagerPlayers", (data) => {
        //     this.players = data;
        // });
  },
  methods: {
    update(data) {
        if (data == null) return;
        this.players = data.players;
        this.currentUser = data.gameState.currentUser;
        if (this.players.length != 0 && this.allowConnection && !this.broadcastStarted && !this.blockDoubleJoin) {
            setTimeout(() => {
                this.blockDoubleJoin = false;
                this.joinBroadcast();
            }, 1000);
            this.blockDoubleJoin = true;
        }

        if (!this.ingamePlayer()) {
            this.refreshCams()
        }
    },
    loadProfile(profile) {
        console.log("loading profile");
        this.profile = profile;
        this.webcamDisplayOption = this.profile.webcamDisplayOption
        this.webcamDisplayStreamId = this.profile.webcamDisplayStreamId
        this.webcamDisplayStreamName = this.profile.webcamDisplayStreamName

        this.$root.$on('gamePlayerChange', (player) => this.toggleActivePlayerCamera(player));

        this.$root.$on('ViewerWebcamsToggleOn', () => {
            this.allowConnection = false;
            this.joinBroadcast();
        });
        this.$root.$on('ViewerWebcamsToggleOff', () => {
            this.stopBroadcast();
            this.allowConnection = false;
        });

        if (this.profile.layout == 3) {
            this.webcamDisplayOption = "webcamDisplayActiveBoard";
        }

        if (this.profile.layout == 4) {
            $(".streamcontainer").appendTo($("body"));
            $(".streamcontainer").addClass("fullLayout");
            $("#app").addClass('webcamFullLayout');
            this.webcamDisplayOption = "webcamDisplayAllCameras"
        }
        console.log(this.webcamDisplayOption);
        this.toggleWebcams();

        // if (this.profile.autostart_webcams == 1) {
        //     document.onreadystatechange = () => {
        //         if (document.readyState == "complete") {
        //         //wait for peerjs to load
        //         this.joinBroadcast();
        //         }
        //     }
        // }
    },
    joinBroadcast() {
        if (this.players.length == 0) return;
        if (this.broadcastStarted) {
            // this.stopBroadcast();
            this.leaveBroadcast();
        }
        let webstreamAllowed = false;
        this.players.forEach(player => {
            if (player.player.user_id == this.auth_user_id) webstreamAllowed = true;
        })
        if (webstreamAllowed) {
            if (this.streams[0]) this.stream1 = new WebcamStream(this.streams[0]['id'], this.streams[0]['user_id'], document.getElementById('video1'), {url: process.env.MIX_TURN_SERVER_URL, username: process.env.MIX_TURN_SERVER_USERNAME, credential: process.env.MIX_TURN_SERVER_CREDENTIAL})
            if (this.streams[1]) this.stream2 = new WebcamStream(this.streams[1]['id'], this.streams[1]['user_id'], document.getElementById('video2'), {url: process.env.MIX_TURN_SERVER_URL, username: process.env.MIX_TURN_SERVER_USERNAME, credential: process.env.MIX_TURN_SERVER_CREDENTIAL})
            if (this.streams[2]) this.stream3 = new WebcamStream(this.streams[2]['id'], this.streams[2]['user_id'], document.getElementById('video3'), {url: process.env.MIX_TURN_SERVER_URL, username: process.env.MIX_TURN_SERVER_USERNAME, credential: process.env.MIX_TURN_SERVER_CREDENTIAL})
            if (this.streams[3]) this.stream4 = new WebcamStream(this.streams[3]['id'], this.streams[3]['user_id'], document.getElementById('video4'), {url: process.env.MIX_TURN_SERVER_URL, username: process.env.MIX_TURN_SERVER_USERNAME, credential: process.env.MIX_TURN_SERVER_CREDENTIAL})
        }
        this.broadcastStarted = true;
        this.$root.$emit('ViewerWebcamsToggledOn');
    },

    reconnect() {
        if (this.stream1) this.stream1.reconnectVideo();
        if (this.stream2) this.stream2.reconnectVideo();
        if (this.stream3) this.stream3.reconnectVideo();
        if (this.stream4) this.stream4.reconnectVideo();
    },

    leaveBroadcast() {
        if (this.stream1) this.stream1.leaveBroadcastVideo();
        if (this.stream2) this.stream2.leaveBroadcastVideo();
        if (this.stream3) this.stream3.leaveBroadcastVideo();
        if (this.stream4) this.stream4.leaveBroadcastVideo();
        this.broadcastStarted = false;
        this.$root.$emit('ViewerWebcamsToggledOff');
    },

    stopBroadcast() {
        if (this.stream1) this.stream1.removeBroadcastVideo();
        if (this.stream2) this.stream2.removeBroadcastVideo();
        if (this.stream3) this.stream3.removeBroadcastVideo();
        if (this.stream4) this.stream4.removeBroadcastVideo();
        this.broadcastStarted = false;
        this.$root.$emit('ViewerWebcamsToggledOff');
    },
    toggleWebcams() {
        if (this.webcamDisplayOption == "webcamDisplayAllCameras") {
            $(".stream").show();
        }
        if (this.webcamDisplayOption == "webcamDisplayActiveBoard") {
            //do not display player streams
            $(".player-stream").hide();
        }
        if (this.webcamDisplayOption == "webcamDisplayHideAll") {
            $(".stream").hide();
        }
    },
    toggleActivePlayerCamera(player) {
        if (this.webcamDisplayOption != "webcamDisplayActivePlayer") return;
        $(".stream").hide();
        $(".stream.user-" + player.playerObj.user_id).show();
    },
    refreshCams() {
        var self = this;
        console.log("refreshing images")
        this.streams.forEach(stream => {
            setTimeout(() => {
            if (stream.name.indexOf("Board") != -1) {
                axios.get("/webcams/boardcam/" + stream.user_id, { responseType:"blob" })
                    .then(function (response) {

                        var reader = new window.FileReader();
                        reader.readAsDataURL(response.data);
                        reader.onload = function() {

                            var imageDataUrl = reader.result;
                            if (self.$refs['stream-' + stream.id])
                                self.$refs['stream-' + stream.id].setAttribute("src", imageDataUrl);

                        }
                    });
            } else {
                axios.get("/webcams/playercam/" + stream.user_id, { responseType:"blob" })
                    .then(function (response) {

                        var reader = new window.FileReader();
                        reader.readAsDataURL(response.data);
                        reader.onload = function() {

                            var imageDataUrl = reader.result;
                            if (self.$refs['stream-' + stream.id])
                                self.$refs['stream-' + stream.id].setAttribute("src", imageDataUrl);

                        }
                    });
            }
            }, 1000)
        });
    },

    ownCameraCheck (stream) {
        return (stream && stream.user_id == this.auth_user_id) ? "muted" : false;
    },
    ingamePlayer() {
        let returnValue = false;
        this.players.forEach(player => {
            if (this.auth_user_id == player.player.user_id) returnValue = true;
        });
        return returnValue;
    },
    streamVisible(stream) {
        if (!stream) return false; //dont show container if stream is not present
        //get the current active user and
        //only show cam if cam is from active user
        if (stream.user_id != this.currentUser) return false;
        return true;
    }
  }
};
</script>

<style scoped>
    .webcamvideo {
        width: 100%;
        height: auto
    }

    .text-small {
        font-size: 0.7rem;
        opacity: 0.8;
    }
</style>

<style>
    #app.webcamFullLayout #maincontent .container-fluid {
        max-width: 60%;
        margin-top: calc(100vh - 26em);
        opacity: 0.9;
    }

    #app.webcamFullLayout #maincontent {
        flex: 0 0 100%;
        max-width: 100%;
    }
    #app.webcamFullLayout #sidebarcontent {
        display: none;
    }

    .streamcontainer.fullLayout {
        position: absolute;
        top: 106px;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: -40;
        gap: 0;
        overflow: hidden
    }

    .streamcontainer.fullLayout :nth-child(1) { order: 1}
    .streamcontainer.fullLayout :nth-child(2) { order: 3}
    .streamcontainer.fullLayout :nth-child(3) { order: 2}
    .streamcontainer.fullLayout :nth-child(4) { order: 4}

    .streamcontainer.fullLayout .stream {
        flex: 1 1 50%;
    }

    .streamcontainer.fullLayout .webcamvideo {
        object-fit: fill;
    }

    .rotate180 {
        transform: rotate(180deg);
    }

    .webcamimage {
        min-height: 5em;
        background-color: var(--full);
    }
</style>
